import getAdvancedSelection from './get-advanced-selection';
import customColors from './custom-colors';

export default {
  getAdvancedSelection,
  ...customColors,
};
